module.exports = __webpack_public_path__ + "static/media/ptcs_logo.e5f68b04.svg";